module.exports = __webpack_public_path__ + "static/media/category13.d0548939.png";